import React from 'react';
import moment, { setDateFormat } from '../../../../lib/moment';
import Section from '../../../../components/outline/Section';
import { setCouponPreviewBtn } from '../../../../lib/utils/couponUtils';
import { setNumberWithComma } from '../../../../lib/common';
import { COUPON_DISCOUNT_TYPE, COUPON_PERIOD_TYPE } from '../../../../constants/service/app/couponConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import './CouponPreview.scss';

const CouponPreview = (props) => {
  const { couponInfo } = props;

  return (
    // 쿠폰 미리보기
    <Section className="coupon-preview" title="쿠폰 미리보기">
      <div className="preview-explain">쿠폰정보/할인타입/기간/적용상품에 따라 서비스에 노출되는 쿠폰 디자인입니다.</div>

      <div className="preview-info">
        <div className="top">
          <div className="title">
            {couponInfo.discountType === COUPON_DISCOUNT_TYPE.PRICE
              ? setNumberWithComma(couponInfo.discountAmount, '원')
              : setNumberWithComma(couponInfo.discountAmount, '%')}
            <span> 할인</span>
          </div>
          <div className="expiration">
            {(couponInfo.periodType === COUPON_PERIOD_TYPE.START_AND_END_DATE ? '오늘 만료됨' : '') +
              (couponInfo.periodType === COUPON_PERIOD_TYPE.DAY_PLUS ? `${couponInfo.dayPlus} 일 남음` : '') +
              (couponInfo.periodType === COUPON_PERIOD_TYPE.INFINITE ? '무기한' : '')}
          </div>
        </div>

        <div className="middle">
          <div className="name">{couponInfo.name}</div>
          <div className="period">
            {(couponInfo.periodType === COUPON_PERIOD_TYPE.START_AND_END_DATE
              ? `${setDateFormat(couponInfo.period.startDate, DATE_FORMAT.FULL_DASH_FORMAT)} ~ ${setDateFormat(
                  couponInfo.period.endDate,
                  DATE_FORMAT.FULL_DASH_FORMAT,
                )}`
              : '') +
              (couponInfo.periodType === COUPON_PERIOD_TYPE.DAY_PLUS
                ? `${setDateFormat(moment(), DATE_FORMAT.FULL_DASH_FORMAT)} ~ ${setDateFormat(
                    moment().add(couponInfo.dayPlus, 'day'),
                    DATE_FORMAT.FULL_DASH_FORMAT,
                  )}`
                : '') +
              (couponInfo.periodType === COUPON_PERIOD_TYPE.INFINITE ? '무기한' : '')}
          </div>
          {setCouponPreviewBtn(couponInfo.availableType)}
        </div>

        <div className="bottom">
          <div className="description">{couponInfo.description}</div>
        </div>
      </div>
      {couponInfo.periodType === COUPON_PERIOD_TYPE.START_AND_END_DATE ? (
        <div className="preview-notice">
          날짜 지정 쿠폰의 미리보기는 '오늘 만료됨' 으로 고정됩니다.
          <br />
          실제 서비스에서는 기간을 반영합니다.
        </div>
      ) : (
        ''
      )}
    </Section>
  );
};

export default CouponPreview;
